import { DesignToggleFavoriteAction, DesignsActionTypes } from '../types';

export const toggleDesignFavoriteAction = (designId: string): DesignToggleFavoriteAction => ({
  type: DesignsActionTypes.TOGGLE_FAVORITE,
  designId,
});
